/**
 * Self-schedule buffer defaults.
 *
 * BE wire shape (kula/core#4973): `interview_buffer_config: { enabled,
 * pre_minutes, post_minutes }` on every `/ats_interviews`,
 * `/ats_schedules`, and `/ats_schedules/settings` payload. Hydration
 * for plan-fed flows lives in `initialValues/fromPlan.ts` (create) +
 * `initialValues/fromEditApi.ts` (edit); the account-level fallback
 * for `self-schedule-adhoc` lives in `api/useAccountBuffer.ts`.
 *
 * These constants seed the wizard's shared state when none of those
 * paths produced a value — and back the auto-seed in
 * `DetailsStep.handleBufferChange` when the user flips toggle-on with
 * stored 0/0 minutes.
 */

export const DEFAULT_BUFFER_BEFORE_MINUTES = 15;
export const DEFAULT_BUFFER_AFTER_MINUTES = 15;
export const BUFFER_STEP_MINUTES = 5;
export const BUFFER_MIN_MINUTES = 0;
export const BUFFER_MAX_MINUTES = 120;
